/**
 * Adds lightweight confirmation feedback to the native Ritual quick add
 * controls used only in the cart recommendation section.
 */
(() => {
  const quickAddSelector = '.dropland-cart-recommendations quick-add-component';
  let pendingQuickAdd = null;
  let toastTimeout = null;

  const getActiveButton = (quickAdd) =>
    quickAdd.querySelector(`.quick-add__button--${quickAdd.dataset.quickAddButton}`);

  const showToast = (productTitle) => {
    let toast = document.querySelector('.dropland-cart-quick-add-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'dropland-cart-quick-add-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    toast.textContent = `${productTitle} agregado al carrito`;
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimeout);
    toastTimeout = window.setTimeout(() => toast.classList.remove('is-visible'), 2000);
  };

  document.addEventListener('click', (event) => {
    const quickAdd = event.target.closest(quickAddSelector);
    if (!quickAdd) return;

    const button = event.target.closest('.quick-add__button');
    if (!button || button.disabled) return;

    pendingQuickAdd = quickAdd;
  });

  document.addEventListener('cart:update', (event) => {
    if (!pendingQuickAdd || event.detail?.data?.didError) return;

    const quickAdd = pendingQuickAdd;
    pendingQuickAdd = null;

    const button = getActiveButton(quickAdd);
    const buttonLabel = button?.querySelector('.add-to-cart-text__content > span > span');
    const card = quickAdd.closest('.dropland-product-card');
    const productTitle = quickAdd.dataset.productTitle || 'Producto';

    if (buttonLabel) {
      const originalLabel = buttonLabel.textContent;
      buttonLabel.textContent = '✓ Agregado';
      window.setTimeout(() => {
        buttonLabel.textContent = originalLabel;
      }, 1000);
    }

    card?.classList.remove('is-quick-added');
    requestAnimationFrame(() => card?.classList.add('is-quick-added'));
    window.setTimeout(() => card?.classList.remove('is-quick-added'), 300);
    showToast(productTitle);
  });
})();
